import { AfterViewInit, Component, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TriageUserDataService } from '../../services/triage-user-data.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-symptom-assessment-bodymap',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './symptom-assessment-bodymap.component.html',
  styleUrl: './symptom-assessment-bodymap.component.scss'
})
export class SymptomAssessmentBodymapComponent implements AfterViewInit {

  genderAge: string = '';
  viewDetail: string = 'triage-body';
  @Output() emitZoneSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextStepTriggered: EventEmitter<void> = new EventEmitter<void>();



  constructor(private triageUserDataService: TriageUserDataService, private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.triageUserDataService.has('age') && this.triageUserDataService.has('gender')) {
      this.initializeData();
    } else {
      console.error('Age and Gender data are missing!');
    }
  }
  
  onImageLoad() {
    setTimeout(() => {
      $('img[usemap]').rwdImageMaps();
    }, 0);
  }

  ngAfterViewInit(): void {
    $('img[usemap]').rwdImageMaps();
  }
  

  initializeData(): void {
    const age = this.triageUserDataService.get('age');
    const gender = this.triageUserDataService.get('gender');
  
    switch (true) {
      case age === 0:
        this.genderAge = 'N';
        break;
      case age < 13:
        this.genderAge = 'B';
        break;
      default:
        this.genderAge = gender;
    }
  }

  showPartPage(bodyPart: string): void {
    this.viewDetail = bodyPart;
  }

  showBodyPartPage(zone: string, label: string): void {
    this.triageUserDataService.set('triageData', { label, zone });
    this.emitZoneSelected.emit(zone);
    this.nextStepTriggered.emit();
  }

  showPrincipalPage(): void {
    this.hideBodyParts();
    this.viewDetail = 'triage-body';
    this.showBodyParts();
  }

  hideBodyParts(): void {
    switch (this.viewDetail) {
      case 'triage-body':
        this.setVisibility('body', false);
        break;
      case 'triage-head':
        this.setVisibility('head', false);
        break;
      case 'triage-chaist':
        this.setVisibility('chaist', false);
        break;
      case 'triage-arms':
        this.setVisibility('arms', false);
        break;
      case 'triage-back':
        this.setVisibility('back', false);
        break;
      case 'triage-stomach':
        this.setVisibility('stomach', false);
        break;
      case 'triage-pelvis':
        this.setVisibility('pelvis', false);
        break;
      case 'triage-hands':
        this.setVisibility('hands', false);
        break;
      case 'triage-legs':
        this.setVisibility('legs', false);
        break;
      case 'triage-foots':
        this.setVisibility('foots', false);
        break;
      default:
        break;
    }
  }

  showBodyParts(): void {
    switch (this.viewDetail) {
      case 'triage-body':
        this.setVisibility('body', true);
        break;
      case 'triage-head':
        this.setVisibility('head', true);
        break;
      case 'triage-chaist':
        this.setVisibility('chaist', true);
        break;
      case 'triage-arms':
        this.setVisibility('arms', true);
        break;
      case 'triage-back':
        this.setVisibility('back', true);
        break;
      case 'triage-stomach':
        this.setVisibility('stomach', true);
        break;
      case 'triage-pelvis':
        this.setVisibility('pelvis', true);
        break;
      case 'triage-hands':
        this.setVisibility('hands', true);
        break;
      case 'triage-legs':
        this.setVisibility('legs', true);
        break;
      case 'triage-foots':
        this.setVisibility('foots', true);
        break;
      default:
        break;
    }
  }

  private setVisibility(part: string, visible: boolean): void {
    const elementMap: { [key: string]: string } = {
      body: `body-${this.genderAge.toLowerCase()}`,
      head: `head-${this.genderAge.toLowerCase()}`,
      chaist: `chaist-${this.genderAge.toLowerCase()}`,
      arms: `arms-${this.genderAge.toLowerCase()}`,
      back: `back-${this.genderAge.toLowerCase()}`,
      stomach: `stomach-${this.genderAge.toLowerCase()}`,
      pelvis: `pelvis-${this.genderAge.toLowerCase()}`,
      hands: `hands-${this.genderAge.toLowerCase()}`,
      legs: `legs-${this.genderAge.toLowerCase()}`,
      foots: `foots-${this.genderAge.toLowerCase()}`,
    };
  
    const className = elementMap[part];
    const element = document.querySelector(`.${className}`);
  
    if (element) {
      if (visible) {
        this.renderer.setStyle(element, 'display', 'block');
      } else {
        this.renderer.setStyle(element, 'display', 'none');
      }
    }
  }
}
